import PropTypes from 'prop-types';
import React from 'react';
import {BreadcrumbsItem} from 'react-breadcrumbs-dynamic';
import {withTranslation} from 'react-i18next';
import NumberFormat from 'react-number-format';
import BaseListContainer from '../baseContainers/BaseListContainer';
import CriteriaCalendarRangeComponent from '../components/criteria/CriteriaCalendarRangeComponent';
import CriteriaDropdownComponent from '../components/criteria/CriteriaDropdownComponent';
import CriteriaNumberRangeComponent from '../components/criteria/CriteriaNumberRangeComponent';
import CriteriaTextComponent from '../components/criteria/CriteriaTextComponent';
import OrderFuelService from '../services/OrderFuelService';
import OrderDetailsDialog from './OrderDetailsDialog';
import {baseReportCsv, baseReportPdf, baseXLSXReport, amountNet, currencyFormat} from '../report/ReportUtils';
import moment from 'moment';

class OrderListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new OrderFuelService());
        this.state = {
            list: [],
            selectedList: [],
            selectAll: false,
            loading: true,
            size: 0,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            statusOpt: [],
            filters: {},
        };
        this.handleOpenDialog = this.handleOpenDialog.bind(this);
        this.handleCloseDialog = this.handleCloseDialog.bind(this);
        this.actionTemplate = this.actionTemplate.bind(this);
        this.handleDtl = this.handleDtl.bind(this);
        this.orderAmountTemplate = this.orderAmountTemplate.bind(this);
    }

    getDataKey() {
        return 'documentNumber';
    }

    getListTitle() {
        return 'order-fuel.listTitle';
    }

    updateSearchCriteria(criteria) {
        return {
            dateFrom: criteria.dateFrom,
            dateTo: criteria.dateTo,
            deliveryDateFrom: criteria.deliveryDateFrom,
            deliveryDateTo: criteria.deliveryDateTo,
            documentNumber: criteria.documentNumber,
            amountFrom: criteria.amountFrom,
            amountTo: criteria.amountTo,
            status: criteria.status,
            text: criteria.text,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }

    onAfterGetList(res) {
        this.props.onAfterGetList(res);
    }

    afterGetListError() {
        this.props.afterGetListError();
    }

    getCleanSearchCriteria() {
        return {
            phoneNumber: this.props.phoneNumber,
            dateFrom:  moment(new Date()).subtract(90, 'days').toDate(),
            dateTo: undefined,
            uninvoiced: this.props.uninvoiced,
            documentNumber: '',
            text: '',
            firstResult: 0,
            maxResults: 10,
            sortField: 'documentNumber',
            sortAsc: false,
        };
    }

    initializeFromBackend() {
        const {t} = this.props;
        if (this._isMounted && !this.props.hideFilters) {
            this.enumService
                .getEnumList('EcOrderFuelStatus', t)
                .then((statusOpt) => {
                    if (this._isMounted) {
                        this.setState({
                            statusOpt,
                        });
                    }
                })
                .catch(() => {
                    this.showErrorMessage(t('error.orderFuelStatusListError'));
                });
        }
    }

    getCriteriaName() {
        return 'order-list-sc';
    }

    getContainerListName() {
        return 'order-list-container';
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    updateListElements(list) {
        return list && list.length
            ? list.map((item) => {
                  item.deliveryDate = new Date(item.deliveryDate);
                  return item;
              })
            : [];
    }

    handleValidForm() {
        this.unblockUi();
    }

    renderCriteria() {
        const {t} = this.props;
        return (
            <div className='row'>
                <CriteriaTextComponent
                    id='documentNumber-sc'
                    name='documentNumber'
                    colClass='col-xl-6 col-lg-6 col-md-12 col-sm-12'
                    value={this.state.criteria.documentNumber}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    placeholder={t('order-fuel.documentNumberPlaceholder')}
                    label={t('order-fuel.documentNumber')}
                    //refreshFromBackend
                />
                <CriteriaCalendarRangeComponent
                    id='date-sc'
                    idFrom='dateFrom-sc'
                    idTo='dateTo-sc'
                    name='date'
                    nameFrom='dateFrom'
                    nameTo='dateTo'
                    label={t('order-fuel.documentDate')}
                    colClass='col-xl-6 col-lg-6 col-md-12 col-sm-12'
                    from={this.state.criteria.dateFrom}
                    to={this.state.criteria.dateTo}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    refreshFromBackend
                    showButtonBar
                    sharedLabel
                    renderDash
                    placeholderFrom={t('cards.from')}
                    placeholderTo={t('cards.to')}
                    inputsClassName='col-6'
                    maxDateInfinite
                />
                <CriteriaCalendarRangeComponent
                    id='deliveryDate-sc'
                    idFrom='deliveryDateFrom-sc'
                    idTo='deliveryDateTo-sc'
                    name='deliveryDate'
                    nameFrom='deliveryDateFrom'
                    nameTo='deliveryDateTo'
                    label={t('order-fuel.deliveryDate')}
                    colClass='col-xl-6 col-lg-6 col-md-12 col-sm-12'
                    from={this.state.criteria.deliveryDateFrom}
                    to={this.state.criteria.deliveryDateTo}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    showButtonBar
                    sharedLabel
                    renderDash
                    placeholderFrom={t('cards.from')}
                    placeholderTo={t('cards.to')}
                    inputsClassName='col-6'
                    inclusiveDate
                    maxDateInfinite
                />

                <CriteriaNumberRangeComponent
                    idFrom='amountFrom-sc'
                    idTo='amountTo-sc'
                    nameFrom='amountFrom'
                    nameTo='amountTo'
                    name='amount'
                    renderDash
                    label={t('order-fuel.amount')}
                    labelFrom={''}
                    labelTo={''}
                    showButtons={false}
                    colClass='col-xl-3 col-lg-6 col-sm-6'
                    from={this.state.criteria.amountFrom}
                    to={this.state.criteria.amountTo}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    allowEmpty
                />
                <CriteriaDropdownComponent
                    id='status-sc'
                    name='status'
                    showClear
                    label={t('cards.status')}
                    colClass='col-xl-3 col-lg-3 col-md-6 col-sm-12'
                    value={this.state.criteria.status}
                    options={this.state.statusOpt}
                    placeholder='Wszystkie'
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    optionLabel='label'
                    dataKey={'enumValue'}
                    // refreshFromBackend
                />
            </div>
        );
    }

    generateReport(format) {
        const {t, lazy} = this.props;
        //const list = this.state.selectedList;
        const list = (this.hasFilter() && this.state.selectAll && lazy === false )? this.processData() : this.state.selectedList;
        if (format === 'csv') {
            const fields = [
                {value: 'documentNumber', label: t('order-fuel.documentNumber')},
                {value: this.dateTemplate.bind(this, 'documentDate', 'DD-MM-YYYY'), label: t('order-fuel.documentDate')},
                {value: this.dateTemplate.bind(this, 'deliveryDate', 'DD-MM-YYYY'), label: t('order-fuel.deliveryDate')},
                {value: 'amount', label: t('order-fuel.value')},
                {value: 'amountVat', label: t('invoice.amountVat')},
                {value: amountNet.bind(this, false, t), label: t('invoice.amountNet')},
                {value: this.enumTemplate.bind(this, 'EcOrderFuelStatus', 'status'), label: t('order-fuel.status')},
            ];
            return Promise.resolve(baseReportCsv(list, fields));
        }
        const columns = [
            {header: t('order-fuel.documentNumber'), field: 'documentNumber'},
            {
                header: t('order-fuel.documentDate'),
                field: 'documentDate',
                getColFunction: this.dateTemplate.bind(this, 'documentDate', 'DD-MM-YYYY'),
            },
            {
                header: t('order-fuel.deliveryDate'),
                field: 'deliveryDate',
                getColFunction: this.dateTemplate.bind(this, 'deliveryDate', 'DD-MM-YYYY'),
            },
            {
                header: t('order-fuel.value'),
                field: 'amount',
                getColFunction: format === 'pdf' ? currencyFormat.bind(this, 'amount', t) : null,
            },
            {
                header: t('invoice.amountVat'),
                field: 'amountVat',
                getColFunction: format === 'pdf' ? currencyFormat.bind(this, 'amountVat', t) : null,
            },
            {header: t('invoice.amountNet'), field: 'amountNet', getColFunction: amountNet.bind(this, format === 'pdf', t)},
            {header: t('order-fuel.status'), field: 'status', getColFunction: this.enumTemplate.bind(this, 'EcOrderFuelStatus', 'status')},
        ];
        if (format === 'pdf') {
            const blob = baseReportPdf({list, title: t(this.getListTitle()), columns, landscape: true}, this.props.t);
            return Promise.resolve(blob);
        } else if (format === 'xlsx' || format === 'ods') {
            const request = {};
            request.columns = columns;
            request.list = list;
            request.sheetName = t(this.getListTitle()).replaceAll(/[*?\][\\/]/g, ' ,');
            return baseXLSXReport(request, format);
        }
    }

    prepareColumns() {
        const {t} = this.props;
        return [
            {
                field: 'documentNumber',
                header: t('order-fuel.documentNumber'),
                sortable: true,
            },
            {
                field: 'documentDate',
                header: t('order-fuel.documentDate'),
                sortable: true,
                body: this.dateTemplate.bind(this, 'documentDate', 'DD-MM-YYYY'),
            },
            {
                field: 'deliveryDate',
                header: t('order-fuel.deliveryDate'),
                sortable: true,
                body: this.dateTemplate.bind(this, 'deliveryDate', 'DD-MM-YYYY'),
            },
            {field: 'amount', header: t('invoice.amount'), sortable: true, body: this.orderAmountTemplate},
            {
                field: 'status',
                header: t('order-fuel.status'),
                sortable: true,
                body: this.enumTemplate.bind(this, 'EcOrderFuelStatus', 'status'),
            },

            {
                key: 'actions',
                header: '',
                body: this.actionTemplate.bind(this),
                className: 'table-column-action',
            },
        ];
    }

    orderAmountTemplate(rowData) {
        const {t} = this.props;
        return (
            <span className='invoice-amount-container'>
                <span className='invoice-amount'>
                    {t('order-fuel.value')}
                    <NumberFormat
                        value={rowData.amount}
                        displayType={'text'}
                        thousandSeparator=' '
                        decimalSeparator=','
                        fixedDecimalScale
                        decimalScale={2}
                        suffix={` ${t('currency.pln')}`}
                        renderText={(value) => value}
                    />
                </span>
                <span className='invoice-amount-vat'>
                    {t('invoice.amountVat')}
                    <NumberFormat
                        value={rowData.amountVat}
                        displayType={'text'}
                        thousandSeparator=' '
                        decimalSeparator=','
                        fixedDecimalScale
                        decimalScale={2}
                        suffix={` ${t('currency.pln')}`}
                        renderText={(value) => value}
                    />
                </span>
                <span className='invoice-amount-netto'>
                    {t('invoice.amountNet')}
                    <NumberFormat
                        value={rowData.amountNetto}
                        displayType={'text'}
                        thousandSeparator=' '
                        decimalSeparator=','
                        fixedDecimalScale
                        decimalScale={2}
                        suffix={` ${t('currency.pln')}`}
                        renderText={(value) => value}
                    />
                </span>
            </span>
        );
    }

    actionTemplate(rowData) {
        const {t} = this.props;
        return (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <a onClick={this.handleOpenDialog.bind(this, rowData)} role='button' tabIndex='0' href='#'>
                <img className='card-icon' alt={t('transaction.details')} src={`/images/ico_chewron_right.svg`} />
            </a>
        );
    }

    handleDtl(rowData) {
        this.props.handleGoToDetail ? this.props.handleGoToDetail(rowData) : this.handleOpenRow.bind(this, rowData);
    }

    prepareHeaderItems() {
        return this.isUserInAnyRole('ROLE_WHOLESALE', 'ROLE_FRANCHISE', 'ROLE_ESPPOL')
            ? [
                  {type: 'LABEL', className: 'float-left'},

                  {
                      type: 'BUTTON',
                      className: 'right-side',
                      variant: 'white',
                      disabled: !this.state.selectedList || this.state.selectedList.length < 1,
                      customRenderFunction: this.renderPrintButton,
                  },
              ]
            : [];
    }

    handleOpenRow(rowData, e) {
        if (e) {
            e.preventDefault();
        }
        this.setState({ids: [rowData.petraId], element: rowData});
    }

    handleOpenDialog(rowData, e) {
        if (e) {
            e.preventDefault();
        }
        const {selectedList} = this.state;
        this.setState({
            ids: selectedList.map((e) => e.petraId),
            cards: selectedList.map((e) => e.cardNumber),
            element: rowData,
        });
    }

    handleCloseDialog(e, callBack) {
        this.setState({element: undefined, ids: [], cards: []}, () => {
            if (callBack) {
                callBack();
            }
        });
    }

    render() {
        const {t} = this.props;
        return (
            <div className='container-fluid order-list-container'>
                {this.state.element ? (
                    <OrderDetailsDialog
                        className='order-fuel-dialog'
                        element={this.state.element}
                        onHide={(e) => this.handleCloseDialog(e)}
                        visible={this.state.element ? true : false}
                        afterSave={(e) =>
                            this.handleCloseDialog(e, () => {
                                this.readMessage();
                                this.refreshTable();
                            })
                        }
                        showMessage={this.props.showMessage}
                        blockUi={this.blockUi}
                        unblockUi={this.unblockUi}
                    />
                ) : null}
                <BreadcrumbsItem to='/card-list'>{t('cards.listName')}</BreadcrumbsItem>
                {this.renderView()}
            </div>
        );
    }
}

OrderListContainer.defaultProps = {
    lazy: false,
    disableSelection: false,
    selectionMode: 'multiple',
    cardTypePanels: false,
    detailUrl: '#/card-details',
    uninvoiced: undefined,
    hideFilters: false,
};

OrderListContainer.propTypes = {
    phoneNumber: PropTypes.string,
    cardTypePanels: PropTypes.bool,
    handleGoToDetail: PropTypes.func,
    uninvoiced: PropTypes.bool,
    hideFilters: PropTypes.bool,
};

export default withTranslation()(OrderListContainer);
